<template>
    <div class="d-flex flex-nowrap align-center justify-center">
        <v-autocomplete v-model="valueLocal" :items="items" :loading="loading" :search-input.sync="search" :label="label" :rules="rules" :item-text="itemText" :item-value="itemValue" :disabled="disabled" :readonly="readonly" hide-no-data cache-items clearable multiple />
        <v-btn v-if="addForm" text small fab class="ml-2" @click="add"><v-icon>mdi-plus</v-icon></v-btn>

        <v-dialog v-model="dialog" max-width="500px">
            <component :is="addForm" v-model="editedItem" @input="onAdd" @cancel="closeDialog" :key="formKey" :filter="filter" />
        </v-dialog>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: [
            'label',
            'url',
            'value',
            'rules',
            'itemText',
            'itemValue',
            'addForm',
            'filter',
            'disabled',
            'setter',
            "readonly"
        ],

        data() {
            return {
                lastSearch: '',
                search: '',
                loading: false,
                autocompleteKey: 0,
                items: [],
                dialog: false,
                editedItem: null,
                formKey: 0
            };
        },

        methods: {
            add() {
                this.formKey++;
                this.editedItem = null;
                this.dialog = true;
            },
            onAdd(item) {
                this.valueLocal.push(item.id);
                this.closeDialog();
            },
            closeDialog() {
                this.dialog = false;
            },
            async load(search) {
                this.lastSearch = search;
                this.loading = true;

                try {
                    var params = { search };

                    if (typeof this.filter !== 'undefined' && this.filter !== null) {
                        Object.keys(this.filter).forEach(key => params['filter.' + key] = this.filter[key]);
                    }

                    var response = await axios.get(this.url, { params });

                    if (this.lastSearch === search) {
                        this.items = response.data.results;
                    }
                } catch {
                    // fail silently
                } finally {
                    if (this.lastSearch === search) {
                        this.loading = false
                    }
                }
            }
        },

        computed: {
            valueLocal: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            }
        },

        watch: {
            async search(search) {
                this.load(search);
            },

            value: {
                immediate: true,
                async handler(value) {
                    if (typeof value === 'undefined' || value === null) {
                        this.search = '';
                        return;
                    }

                    // If the selected value (or values) are not available in the list, then load them.
                    var ids = value;
                    var itemIds = this.items.map(i => i[this.itemValue]);
                    if (!ids.some(id => !itemIds.includes(id))) {
                        // There are no ids missing, so we can return.
                        return;
                    }

                    var params = {
                        take: ids.length
                    };

                    params.ids = ids;
                    var response = await axios.get(this.url, { params });
                    this.items = response.data.results;
                }
            },

            filter: {
                async handler() {
                    await this.load(this.search);
                    this.autocompleteKey++;
                }
            }
        }
    };
</script>
